import { render, staticRenderFns } from "./RSRecordEdit.vue?vue&type=template&id=45358d5b&scoped=true&"
import script from "./RSRecordEdit.vue?vue&type=script&lang=js&"
export * from "./RSRecordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45358d5b",
  null
  
)

export default component.exports